import {getMeta} from './helpers';
import {Application} from '@hotwired/stimulus';
import AxiosFormController from './controllers/axios-form-controller';
import ExpandableController from './controllers/expandable-controller';
import LeafletController from './controllers/leaflet-maps-controller';
import ModalController from './controllers/modal-controller';
import SliderController from './controllers/slider-controller';
import TabController from './controllers/tab-controller';
import ProductFilterController from './controllers/product-filter-controller';
import QuantityController from './controllers/quantity-controller';
import ToggleController from './controllers/toggle-controller';

// Set webpack public asset url
window.__webpack_public_path__ = getMeta('theme-url');

require('./navigation');
require('./lightbox');
require('./login');

const application = Application.start();

application.register('axios-form', AxiosFormController);
application.register('modal', ModalController);
application.register('tab', TabController);
application.register('slider', SliderController);
application.register('expandable', ExpandableController);
application.register('leaflet', LeafletController);
application.register('product-filter', ProductFilterController);
application.register('quantity', QuantityController);
application.register('toggle', ToggleController);